export default __webpack_public_path__ + "static/media/por.d8c43645.jpg";